export default {
  providers: ['facebook', 'twitter', 'linkedin'],
  hashtag: 'vychovakzivotu',
  // use placeholders to interpolate presentation variables
  // {title} - presentation title
  message: 'Vychutnavam si prednasku: {title}',
  url: 'https://vychovakzivotu.com',
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/addons/socialShare/presentation.js